import React, { useEffect } from 'react';
import './Filter.scss';
import Button from "@mui/material/Button";
import {PermissionsCheck} from '../../Utils/Common';

function SimpleFilter({ apiURL, fetchData, reload, permission }) {

    useEffect(() => {
        // check so 1st render does not do load
        if (reload) {
            handleLoadData();
        }
    }, [reload]);

    const handleLoadData = () => {
        // console.log("load url ", apiURL);
        fetchData(apiURL);
    };

    return (
        <div class="filterPanel">
            <PermissionsCheck
                errorProps={{ disabled: true }}
                RenderError={() => <></>}
                scopes={permission}>
                <Button variant='contained' size="small" onClick={handleLoadData}
                    sx={{
                        lineHeight: 'normal',
                        textTransform: 'none',
                        background: '#82C027',
                        color: '#333330',
                        '&:hover': {
                            backgroundColor: '#82C027',
                            boxShadow: 'none',
                        }
                    }}>Load</Button>
            </PermissionsCheck>
        </div>
    );

}

export default SimpleFilter